import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { FormattedMessage } from '../../util/reactIntl';
import { PaginationLinks, NamedLink } from '../../components';
import ListingResults from './components/ListingResults/ListingResults.js';
import EnquiryResults from './components/EnquiryResults/EnquiryResults';
import ClassResults from './components/ClassResults/ClassResults';
import CompanyResults from './components/CompanyResults/CompanyResults';
import css from './SearchResultsPanel.css';
import { LISTING_TYPES } from 'util/constants';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings,
    pagination,
    search,
    pageName = 'SearchPage',
    setActiveListing,
    allListingReview = {},
    allAuthorNumberOfListings = {},
    params = {},
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const content = useMemo(() => {
    if (!listings.length) return null;

    const type = search.pub_listing_type || 'listing';

    switch (type) {
      case LISTING_TYPES.LISTING:
      case LISTING_TYPES.FACILITY:
      case LISTING_TYPES.PRODUCT:
      case LISTING_TYPES.MEMBERSHIP:
        return (
          <ListingResults
            listings={listings}
            setActiveListing={setActiveListing}
            allListingReview={allListingReview}
          />
        );
      case LISTING_TYPES.ENQUIRY:
        return <EnquiryResults listings={listings} setActiveListing={setActiveListing} />;
      case LISTING_TYPES.CLASS:
      case LISTING_TYPES.EVENT:
        return (
          <ClassResults
            listings={listings}
            setActiveListing={setActiveListing}
            searchParams={search}
            allClassListingReviews={allListingReview}
          />
        );
      case LISTING_TYPES.COMPANY:
      case LISTING_TYPES.FREELANCER:
        return (
          <CompanyResults
            listings={listings}
            setActiveListing={setActiveListing}
            searchParams={search}
            allAuthorNumberOfListings={allAuthorNumberOfListings}
            allClassListingReviews={allListingReview}
          />
        );
      default:
        return 'Unknown listing type';
    }
    /* eslint-disable-next-line */
  }, [listings, search.pub_listing_type]);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName={pageName}
        pageSearchParams={search}
        pagePathParams={params}
        pagination={pagination}
      />
    ) : null;

  return (
    <div className={classes}>
      <div>
        {content}
        {props.children}
        <div className={css.connectPros}>
          <h4 className={css.connectProsTitle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="18"
              viewBox="0 0 11 18"
              fill="none"
            >
              <path
                d="M4.5 10H0L8.21429 0L6.5 7.5H10.5L1.78571 18L4.5 10Z"
                fill="url(#paintSearchResultsPanel_linear_4633_167)"
              />
              <defs>
                <linearGradient
                  id="paintSearchResultsPanel_linear_4633_167"
                  x1="5"
                  y1="2.42782e-09"
                  x2="-3.48706"
                  y2="17.1585"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#10D6EB" />
                  <stop offset="1" stopColor="#0095B3" />
                </linearGradient>
              </defs>
            </svg>
            <FormattedMessage id="LandingPage.getMatchesFaster" />
          </h4>
          <NamedLink name="NewInquirePage" className={css.startRequestFormButton}>
            <FormattedMessage id="LandingPage.tryProConnect" />
          </NamedLink>
        </div>
      </div>
      {paginationLinks}
    </div>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  pagination: null,
  rootClassName: null,
  search: null,
  allListingReview: {},
  params: {},
};

const { array, node, object, string } = PropTypes;

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
  urlQueryParams: object,
  allListingReview: object,
  params: object,
};

export default SearchResultsPanel;
